// import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {getPriceWithCurrency, toFixedFeatureCost, toFixedPrice} from "../../../../../misc/helpers";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {getCurrentLayout} from "../../../../appLayout";
import {isVisibleForNavigation} from "../../../../../misc/displayLogic";
import React from "react";

const GroheFeaturesTotalPrice = (props) => {

  const {features, quantity, fabricatorData} = props;
  const fabricatorSettings = fabricatorData.settings;

  if (!features) {
    return null;
  }

  const layout = getCurrentLayout();

  // let totalFeaturesPrice = features.forEach((feature) => {
  //
  // });
  let totalFeaturesPrice = 0;
  for (const feature of features) {
    if (!isVisibleForNavigation(feature, true)) {
      continue;
    }

    if (!layout.partIdExistInQtCategory(feature.partId)) {
      continue;
    }

    totalFeaturesPrice += +toFixedFeatureCost(feature, Number.isInteger(quantity) ? quantity : 1);
  }

  return (
    <span className="grohe-features__price bold">
      <span><FormattedMessage id="grohe.feature.total"/></span>
      <span>: </span>
      <span> {getPriceWithCurrency(fabricatorSettings, toFixedPrice(totalFeaturesPrice), null, false)}</span>
    </span>
  )
};

GroheFeaturesTotalPrice.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  withUnit: PropTypes.bool,
  withDecimals: PropTypes.bool,
  quantity: PropTypes.number,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

export default injectIntl(
  connect(mapStateToProps)(GroheFeaturesTotalPrice)
)
